<template>
  <div>
   <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :loader="'dots'"
      :height="150"
      :width="150"
      :color="'#F1557A'"
      :is-full-page="fullPage"
    ></loading>
    <v-tour v-if="welcomeUser == false" name="myTour" :steps="steps"></v-tour>
    <div class="banner" id="step-2">
      <h1 class="dashboard-h1">Welcome back {{ this.Name }}!</h1>
      <p class="dashboard-p">
        Your team created {{ this.weeklystatsVideo }} videos this week and completed {{this.WeeklyTodoCompleted}}% of the outstanding
        To Dos.
      </p>
      <d-button class="btn-blue" @click="openModal">
        <i class="material-icons">add</i> Create To Do
      </d-button>
    </div>
    <sweet-modal ref="modal">
      <strong class="text-muted text-left d-block mb-2">Select Supporters</strong>
      <d-input-group class="mb-3">
        <multiselect
          :close-on-select="false"
          placeholder
          label="name"
          v-model="selectedSupporter"
          :multiple="true"
          track-by="name"
          :options="options"
        ></multiselect>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2">Select a User</strong>
      <d-input-group class="mb-3">
        <d-select :value="selectedUser" @change="onchangeUser">
          <option>Select</option>
          <option
            v-for="(employee, index) in allEmployees"
            :key="index"
            v-bind:value="employee._id"
          >{{ employee.first_name + " " + employee.last_name }}</option>
        </d-select>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2">Select a Call-To-Action</strong>
      <d-input-group class="mb-3">
        <d-select :value="selectedCTA" @change="onchangeCta">
          <option>Support our new campaign - One-Time Donation</option>
          <option
            v-if="allCTA.length > 0"
            v-for="(cta, index) in allCTA"
            :key="index"
            v-bind:value="cta.id"
          >{{ cta.title + " - " + cta.type }}</option>
        </d-select>
      </d-input-group>
      <br />
      <br />
      <d-button @click.prevent="assignTodo()" class="btn-blue btn-right">Assign</d-button>
    </sweet-modal>
    <d-container fluid class="main-content-container px-4 py-4 dark-bg p-2">
      <d-row class="list-button-row">
        <div class="list-button-group">
          <a
            class="list-button-home"
            v-bind:class="{ 'list-button-active': dashboardTab == 0 }"
            @click="selectDash(0)"
          >Stats</a>
          <a
            class="list-button-home"
            v-bind:class="{ 'list-button-active': dashboardTab == 1 }"
            @click="selectDash(1)"
          >
            Approval Required
            <span
              v-if="this.approvalNotifications != 0"
              class="approval-notifications"
            >{{this.approvalNotifications}}</span>
          </a>
          <a
            class="list-button-home"
            v-bind:class="{ 'list-button-active': dashboardTab == 2 }"
            @click="selectDash(2)"
          >Sent Videos</a>
          <a
            class="list-button-home"
            v-bind:class="{ 'list-button-active': dashboardTab == 3 }"
            @click="selectDash(3)"
          >Video Library</a>
          <a
            class="list-button-home"
            v-bind:class="{ 'list-button-active': dashboardTab == 4 }"
            @click="selectDash(4)"
          >Donations</a>
        </div>
      </d-row>
      <!-- Page Header -->
      <div class="dashboard-tab no-shadow" v-if="this.dashboardTab == 0">
        <d-row class="py-3 date-picker">
          <d-col col sm="12" class="d-flex mb-2 mb-sm-0">
            <d-input-group
              size="sm"
              class="date-range d-flex"
              style="justify-content: flex-end; margin-top: 17px;"
            >
              <d-datepicker
                @click.native="handleDateSelect"
                v-model="dateRange.from"
                :highlighted="{
                  from: dateRange.from,
                  to: dateRange.to || new Date()
                }"
                placeholder="Start Date"
                typeable
                small
              />
              <d-datepicker
                @click.native="handleDateSelect"
                v-model="dateRange.to"
                :highlighted="{
                  from: dateRange.from,
                  to: dateRange.to || new Date()
                }"
                placeholder="End Date"
                typeable
                small
              />
              <d-input-group-text slot="append" style="max-height: 31px;">
                <i class="material-icons">&#xE916;</i>
              </d-input-group-text>
            </d-input-group>
          </d-col>
        </d-row>

        <!-- Small Stats Blocks -->
        <d-row class="p-3">
          <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4 small-stat-container">
            <small-stats
              :id="`small-stats-${idx}`"
              variation="1"
              q
              :chart-data="stats.datasets"
              :label="stats.label"
              :explanation="stats.explanation"
              :value="stats.value"
            />
          </d-col>
        </d-row>
      </div>
      <div class="dashboard-tab no-shadow" v-if="this.dashboardTab == 1">
        <ApprovalQueue class="wrap" />
      </div>
      <div class="dashboard-tab no-shadow" v-if="this.dashboardTab == 2">
        <SentVideos class="wrap" />
      </div>
      <div class="dashboard-tab no-shadow" v-if="this.dashboardTab == 3">
        <VideoLibrary class="wrap" />
      </div>
      <div class="dashboard-tab no-shadow" v-if="this.dashboardTab == 4">
        <Donation class="wrap2" />
      </div>
    </d-container>
  </div>
</template>

<script>
import SmallStats from "@/components/common/SmallStats.vue";
import TopReferrals from "@/components/common/TopReferrals.vue";
import UsersOverview from "@/components/blog/UsersOverview.vue";
import UsersOverviewFunnel from "@/components/blog/UsersOverviewFunnel.vue";
import UsersByDevice from "@/components/blog/UsersByDeviceLite.vue";
import NewDraft from "@/components/blog/NewDraft.vue";
import ActionFeed from "@/components/blog/ActionsFeed.vue";
import TierFeed from "@/components/blog/TiersFeed.vue";
import { lock } from "../vuex/auth/webAuth";
import ctaTypes from "../vuex/cta/cta.types";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import TodoTypes from "../vuex/todos/todos.types";
import managerTypes from "../vuex/manager/manager.types";
import supportersTypes from "../vuex/supporters/supporters.types";
import actionsTypes from "../vuex/actions/actions.types";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import tiersTypes from "../vuex/tiers/tiers.types";
import dashTypes from "../vuex/dash/dash.types";
import SentVideos from "./SentVideos.vue";
import ApprovalQueue from "./ApprovalQueue.vue";
import VideoLibrary from "./VideoLibrary.vue";
import storage from "../helpers/storage";
import Loading from "vue-loading-overlay";
import Donation from './Donation.vue'
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    SmallStats,
    Loading,
    boUsersOverview: UsersOverview,
    boUsersOverviewFunnel: UsersOverviewFunnel,
    boUsersByDevice: UsersByDevice,
    boNewDraft: NewDraft,
    TierFeed,
    SentVideos,
    SweetModal,
    Multiselect,
    SweetModalTab,
    ApprovalQueue,
    VideoLibrary,
    ActionFeed,
    Donation,
    boTopReferrals: TopReferrals
  },
  data() {
    const date = new Date();
    return {
      approvalNotifications:0,
      selectedSupporter: [],
      options: [],
      fullPage: true,
      isLoading: false,
      selectedUser: null,
      weeklystatsVideo: 0,
      weeklystatspercentage: null,
      WeeklyTodoCompleted : 0,
      allEmployees: [],
      selectedCTA: null,
      allCTA: [],
      user: {},
      name: "my-tour",
      dateRange: {
        from: date.setMonth(date.getMonth() - 1),
        to: new Date()
      },
      supporters: 0,
      actions: 0,
      welcomeUser: storage.get("manager").wizardComplete,
      analytics: {
      totalRevenue: 0,
      monthlyDonation: 0,
      monthlyDonors: 0,
      totalDonations: 0,
      play_rate: 0,
      page_views: 0,
      video_views: 2,
      donation_rate: 0,
      engamentRate: 0,
      abandonedRate: 0,
      donors: 0,
      monthlyRevenue:0
      },
      chartData: {},
      chartDatas: [],
      actionActivities: [],
      tierActivities: [],
      supportersData: [],
      videos: [],
      dashboardTab: "0",
      steps: [
        {
          target: "#step-1", // We're using document.querySelector() under the hood
          content: `Welcome to GiveMagic!`
        },
        {
          target: "#step-2",
          content:
            "You'll see some simple stats here and over time suggestions on how to improve your stories.",
          params: {
            highlight: true
          }
        }
      ]
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));

    const ls = storage.get("manager");
    this.Name = ls.first_name;

    if (!this.welcomeUser) {
      this.$tours["myTour"].start();
      this.$store.dispatch("updateWelcome");
    }
  },
  created() {
    this.$store.dispatch("fetchPendingVideo");
    this.$store.dispatch("fetchWeeklyAnalytics");
     this.$store.dispatch("fetchAnalytics", this.dateRange);
    analytics.page("Dashboard");
    this.$store.dispatch("fetchAllCTA");
    this.$store.dispatch("fetchAllEmployees");
    this.$store.dispatch("fetchsupporters");
    this.$store.dispatch("fetchTiers");
    this.$store.dispatch("fetchActions");
    this.$store.dispatch("fetchTiersActivities");
    this.$store.dispatch("fetchActionsActivities");
    this.$store.dispatch("fetchAnalytics");
    // this.$store.dispatch("fetchAnalytics", this.dateRange);
    
    setInterval(() => {
      // this.$store.dispatch("fetchAnalytics", this.dateRange);
      this.$store.dispatch("fetchTiersActivities");
      this.$store.dispatch("fetchActionsActivities");
      
    }, 10000);
  },
  methods: {
    onchangeCta(cta) {
      if (cta != "Support our new campaign - One-Time Donation") {
        this.selectedCTA = cta;
      } else {
        this.selectedCTA = null;
      }
    },
    closeModal() {
      this.$refs.modal.close();
    },
    onchangeUser(user) {
      if (user != "Select") {
        this.selectedUser = user;
      } else {
        this.selectedUser = null;
      }
    },
    assignTodo() {
      if (!this.selectedSupporter || !this.selectedSupporter.length) {
        alert("Please Select Supporters First");
      } else if (!this.selectedUser) {
        alert("Please Select User");
      } else if (
        !this.selectedCTA ||
        this.selectedCTA == "Support our new campaign - One-Time Donation"
      ) {
        alert("Please Select CTA");
      } else {
        this.closeModal();
        if (this.selectedSupporter && this.selectedSupporter.length) {
          this.mySupporters = [];
          this.selectedSupporter.map(item => {
            this.mySupporters.push(item.id);
          });
        }
        var obj = {
          supporters: this.mySupporters,
          cta: this.selectedCTA,
          employee: this.selectedUser
        };
        this.$store.dispatch("assignTodo", obj);
        analytics.track("Created To Do");
      }
    },
    openModal() {
      this.$refs.modal.open();
      analytics.track("Clicked Create To Do");
    },
    selectDash(id) {
      this.dashboardTab = id;
    },
    handleDateSelect() {
      this.$store.dispatch("fetchAnalytics", this.dateRange);
    },
    handleApprove(id) {
      alert(`Approving discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleReject(id) {
      alert(`Rejecting discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleEdit(id) {
      alert(`Editing discussion id: ${id}`); // eslint-disable-line no-alert
    },
    handleViewAllComments() {
      alert("Viewing all comments!"); // eslint-disable-line no-alert
    }
  },
  watch: {
    todoType(type) {
      if (type === TodoTypes.ADD_TODOS_REQUEST) {
        this.isLoading = true;
      } else if (type === TodoTypes.ADD_TODOS_SUCCESS) {
        this.isLoading = false;
        this.selectedSupporter = [];
        this.selectedCTA = null;
        this.selectedUser = null;
        this.$toasted.success("Todo assigned successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === TodoTypes.ADD_TODOS_FAILED) {
        this.isLoading = false;
        this.selectedSupporter = [];
        this.selectedCTA = null;
        this.selectedUser = null;
        this.$toasted.error(this.todoerror, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    },
    ctaType(type) {
      if (type == ctaTypes.FETCH_CTAS_SUCCESS) {
         var sortDAta = []
        this.ctas.actions.map((item,index)=>{
         if(!item.archived){
          sortDAta.push(item)
          }
        })
        this.allCTA = sortDAta;
      }
    },
    clientType(type) {

      if (type === managerTypes.FETCH_manager_SUCCESS) {
        this.allEmployees = this.employees.employees;
      } else if (type === managerTypes.FETCH_WELCOME_SUCCESS) {
      }
    },
    fetchActionActivitiesSuccess(activity) {
      if (activity) {
        this.actionActivities = this.activitiesData.actionActivities;
      }
    },
    fetchTierActivitiesSuccess(activity) {
      if (activity) {
        this.tierActivities = this.activitiesData.tierActivities;
      }
    },
    chartDatas(newData) {
      if (newData) {
        this.chartData = {
          datasets: [
            {
              hoverBorderColor: "#ffffff",
              data: Object.values(newData),
              backgroundColor: [
                "rgba(0,123,255,0.9)",
                "rgba(0,123,255,0.5)",
                "rgba(0,123,255,0.3)"
              ]
            }
          ],
          labels: Object.keys(newData)
        };
      }
    },
    type(newType) {
      if (newType === supportersTypes.FETCH_supporterS_SUCCESS) {
        let allSupporters = this.data.supporters;
        if (allSupporters && allSupporters.length) {
          allSupporters.map(item => {
            this.options.push({
              name: `${item.first_name} ${item.last_name}`,
              id: item._id
            });
          });
        }
        this.supporters = this.data.supporters.length;
        const tiers = this.tiersData.tiers || [];
        const tierNames = [];
        const data = [];
        tiers.forEach(tier =>
          tierNames.push({
            name: tier.name,
            level: tier.level
          })
        );
        if (this.data.supporters) {
          this.data.supporters.forEach(supporter => {
            tierNames.forEach(tierName => {
              if (supporter.level === tierName.level && !data[tierName.name]) {
                data[tierName.name] = 1;
              } else if (
                supporter.level === tierName.level &&
                data[tierName.name]
              ) {
                data[tierName.name] += 1;
              }
            });
          });
        }
        this.chartDatas = data;
      }
    },
    actionsType(newType) {
      if (newType === actionsTypes.FETCH_ACTIONS_SUCCESS) {
        this.actions = this.actionsData.actions.length;
      }
    },
    tiersType(newType) {
      if (newType === tiersTypes.FETCH_TIERS_SUCCESS) {
        const tiers = this.tiersData.tiers || [];
        const tierNames = [];
        const data = [];
        tiers.forEach(tier =>
          tierNames.push({
            name: tier.name,
            level: tier.level
          })
        );
        if (this.data.supporters) {
          this.data.supporters.forEach(supporter => {
            tierNames.forEach(tierName => {
              if (supporter.level === tierName.level && !data[tierName.name]) {
                data[tierName.name] = 1;
              } else if (
                supporter.level === tierName.level &&
                data[tierName.name]
              ) {
                data[tierName.name] += 1;
              }
            });
          });
        }
        this.chartDatas = data;
      }
    },
    analyticsType(newType) {
      if (newType === dashTypes.FETCH_ANALYTICS_SUCCESS) {
        this.analytics =  this.analyticsData
        // this.analytics = Object.assign(
        //   this.analytics,
        //   this.analyticsData.analytics
        // );
      }
      else if (newType === dashTypes.FETCH_WEEKLY_SUCCESS) {
          this.weeklystatsVideo = this.weeklyStats.videosCreated
          var calculation = this.weeklyStats.TodosCompleted / this.weeklyStats.todosAssigned 
          var percecntage = calculation * 100
          this.WeeklyTodoCompleted = Math.round(percecntage)
        }
      },
      
    videoType(e) {
     if (e === "FETCH_PENDINGDVIDEO_SUCCESS") {
        this.approvalNotifications = this.fetchPendingData.totalDocs;
      }

    },
    updateActionLoading(loading) {
    }
  },
  computed: {
    ...mapState({
      data: state => state.supporters.data,
      fetchData: state => state.dash.fetchData,
      type: state => state.supporters.type,
      actionsData: state => state.actions.data,
      tiersType: state => state.tiers.type,
      tiersData: state => state.tiers.data,
      actionsType: state => state.actions.type,
      analyticsData: state => state.dash.data,
      analyticsType: state => state.dash.type,
      todoType: state => state.todos.type,
      todoerror: state => state.todos.error,
      ctaType: state => state.cta.type,
      ctas: state => state.cta.data,
      clientType: state => state.manager.type,
      welcomeTour: state => state.manager.welcome,
      employees: state => state.manager.data,
      activitiesData: state => state.activities.data,
      // supportersData: state => state.supporter.data,
      statsType: state => state.dash.type,
      weeklyStats: state => state.dash.weekly,
      error: state => state.dash.error,
      fetchStatsData: state => state.dash.data,
      // dashTypes:state => state.dash.type,
      weekly:state => state.dash.weekly,
      videoType: state => state.dash.type,
      fetchPendingData: state => state.dash.fetchPendingData
    }),
    ...mapGetters([
      "updateActionLoading",
      "updateActionSuccess",
      "updateActionFailed",
      "addActionLoading",
      "addActionSuccess",
      "addActionFailed",
      "fetchActionsLoading",
      "fetchActionsSuccess",
      "fetchActionsFailed",
      "fetchActionActivitiesSuccess",
      "fetchTierActivitiesSuccess",
      "fetchDashLoading",
      "fetchDashSuccess",
      "fetchDashFailed"
    ]),
    smallStats() {
      const supporters = this.supporters;
      const actions = this.actions;
      const analytics = this.analytics;
      return [
        {
          label: "Opens",
          explanation: "The number of page loads, not unique. If the same person loaded your page 2 times, it would be included.",
          value: `${analytics.page_views}`,
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },
        {
          label: "Play Rate",
          explanation: "This tells you the percentage of people watching your stories. We calculate it by dividing unique plays by unique page loads. ",
          value:  `${
            analytics.play_rate ? analytics.play_rate.toFixed(1) : 0
          }%`,
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },
        {
          label: "Plays",
          value: `${analytics.video_views}`,
          explanation: "The total number of video views for your organization. If someone watches the same video twice, it's included in this number.",
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },
        {
          label: "Engagement Rate",
          value: `${analytics.engamentRate.toFixed(1)}%`,
          explanation: "Measures playback of your video which shows you how much attention your viewers are giving to your stories. If you're over 70%, you're doing really well!",
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },

        {
          label: "Donate Rate",
          value: `${analytics.donation_rate.toFixed(1)}%`,
          explanation: "This tells you how well your stories are performing. We divide the number of donations by unique page loads. If you're above 3%, you're doing great!",
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },
        {
          label: "Abandoned Rate",
          value: `${analytics.abandonedRate.toFixed(1)}%`,
          explanation: "This tells you the percentage of people that are abandoning a checkout journey, the standard for donate forms is 85%.",
          percentage: "2.4%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        },
        {
          label: "Total Revenue",
          value: `$${analytics.totalRevenue}`,
          explanation: "This tells you how much is being transacted via GiveMagic, before any platform or processing fees. Includes one-time and monthly.",
          percentage: "4.7%",
          increase: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(0, 184, 216, 0.1)",
              borderColor: "rgb(0, 184, 216)",
              data: [1, 2, 1, 3, 5, 4, 7]
            }
          ]
        },
        {
          label: "Donors",
          value: Math.round(
            analytics.donors ? analytics.donors : 0
          ),
          explanation: "The number of unique people who have donated to your organization within the designated time period.",
          percentage: "12.4",
          increase: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(23,198,113,0.1)",
              borderColor: "rgb(23,198,113)",
              data: [1, 2, 3, 3, 3, 4, 4]
            }
          ]
        },
        {
          label: "Monthly Donors",
          value: `${Math.round(
            analytics.monthlyDonors ? analytics.monthlyDonors : 0
          )}`,
          explanation: "The number of unique people who have donated monthly to your organization within the designated time period.",
          percentage: "2.71%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,65,105,0.1)",
              borderColor: "rgb(255,65,105)",
              data: [1, 7, 1, 3, 1, 4, 8]
            }
          ]
        },
        {
          label: "Monthly Revenue",
          value:`$${analytics.monthlyRevenue}`,
          explanation: "This tells you how much is being transacted monthly via GiveMagic during this time period, before any platform or processing fees. Includes previous monthly donations not initated, but billed during this period. ",
          percentage: "3.8%",
          increase: false,
          decrease: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,180,0,0.1)",
              borderColor: "rgb(255,180,0)",
              data: [2, 3, 3, 3, 4, 3, 3]
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss">
@import "../dist/vue-multiselect.min.css";
.dashboard-p {
  opacity: 0.8;
}
.dashboard-h1 {
  font-weight: 600;
}
.date-picker {
  margin-right: 5px;
}
.date-range {
  justify-content: flex-start !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  margin-left: 10px;
  zoom: 1.2;
}

.wrap {
  display: flex;
  flex-wrap: wrap;
}
.wrap2 {
  flex-wrap: wrap;
}
.banner {
  height: 225px;
  border-radius: 10px;
  padding: 50px;
  margin: 0 auto;
  background-image: linear-gradient(-153deg, #494980 5%, #232349 100%);
  margin: 40px;
  color: white;
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
  h1 {
    color: #fff;
  }
}

.dashboard-tab {
  margin-top: 25px;
  margin-right: 15px;
  margin-left: 15px;
  border-radius: 10px;
  padding: 25px;
  background: #fff;
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
}
.no-shadow {
  background: none;
  box-shadow: none;
  padding: 0;
  margin: 25px 0 0;
}
.dark-bg {
  margin-bottom: 25px;
  .page-header .page-title {
    color: #3d5170;
  }
  .page-header .page-subtitle {
    color: white;
  }
}
.list-button-home {
  padding: 10px;
  border-radius: 5px;
  padding-left: 15px;
  padding-right: 15px;
  // background: #f5f5f9;
  margin: 5px;
  cursor: pointer;
  font-weight: 600;
}
.list-button-home:hover {
  background: #f5f5f9;
}
.list-button-active {
  font-weight: 600;
  background: #f5f5f9;
  color: #f2557a !important;
}

.approval-notifications {
  padding: 2px 7.4px 2px 7px;
  background: #f2557a;
  opacity: 0.9;
  border-radius: 50px;
  margin: 5px;
  color: white;
  font-size: 0.95rem;
  font-weight: 700;
}
.list-button-group {
  font-size: 1.1rem;
  margin-left: 25px;
}

.small-stat-container {
  flex-basis: 20%;
}
.wip {
  margin-right: 20px;
  /* right: 13px; */
  /* left: 14px; */
  position: absolute;
  width: 98%;
  height: 100%;
  margin: 0 auto;
  background: #f2f7fdad;
  z-index: 100;
}
.wip-text {
  text-align: center;
  margin-top: 150px;
  font-size: 40px;
}
.input-group-sm .vdp-datepicker input {
  border-radius: 5px;
  border: 2px solid #fff !important;
  background: #f5f5f9;
  color: black;
  text-transform: uppercase;
}
div.vdp-datepicker__calendar .cell.highlighted {
  background: #f2557a !important;
}
div.vdp-datepicker__calendar .cell.selected {
  background: #f2557a !important;
}
div.vdp-datepicker__calendar .cell.highlighted.selected,
div.vdp-datepicker__calendar .cell.selected {
  background: #be415e !important;
}

div.vdp-datepicker__calendar .cell.highlighted.selected,
div.vdp-datepicker__calendar .cell.selected {
  background: #be415e !important;
}
.page-item {
}
.page-link-item {
}
.prev-item {
}
.prev-link-item {
}
.next-item {
}
.next-link-item {
}
.break-view {
}
.break-view-item {
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline;
}
.pagination > li:first-child > a {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
</style>
